/**
 Project	IAM - Validation

 @file 	    maintenance-list-fields,models.ts
 @author  	Martin Tazlari <martin.tazlari@ictvs.ch>
 @copyright © 2018, ICT-vs. All rights reserved.
 **/

export class MaintenanceListFields {
  type: string;
  title: string;
  titre_fr: string;
  titre_de: string;
  texte_fr: string;
  texte_de: string;
  location: string;
  startdate: string;
  enddate: string;
  color: string;
  service_oid: string;
}
